import { type ReactNode } from 'react';
import { ThemeToggle } from '@doccareplus/ui';
import { PortalBrandSide } from './PortalBrandSide';

// Two-panel auth shell (brand panel left, form right), mirroring the clinic login/register layout. Both the
// login and register pages compose it, so the app logo, heading, and framing stay consistent.
export function PortalAuthLayout({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle: string;
  children: ReactNode;
  footer: ReactNode;
}) {
  return (
    <div className="flex min-h-[100dvh] bg-[var(--bg)]">
      <ThemeToggle className="fixed right-4 top-4 z-50 shadow-[var(--shadow-1)]" />

      <PortalBrandSide />

      <div className="flex w-full flex-col justify-center overflow-y-auto bg-[var(--surface)] px-6 pb-12 pt-16 sm:px-12 lg:w-[520px]">
        <div className="mx-auto w-full max-w-[390px]">
          <div className="mb-6 flex flex-col items-center text-center">
            <img src="/long_logo.svg" alt="DocCare+" className="mb-4 h-[46px]" />
            <h2 className="text-xl font-bold tracking-tight text-[var(--text)]">{title}</h2>
            <p className="mt-1.5 text-[13px] text-[var(--text-3)]">{subtitle}</p>
          </div>

          {children}

          <div className="mt-8 border-t border-[var(--border)] pt-4 text-center text-[13px] text-[var(--text-3)]">
            {footer}
          </div>
        </div>
      </div>
    </div>
  );
}
